import { useState } from "react";
import { url } from '../utils/config';
import QRCode from "react-qr-code";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";


function AddVanEquipment(props) {
    const [ formData, setFormData ] = useState({
        mobile_van_id: props.mobileVanId, 
        special_equipment_id: props.specialEquipments[0]['id']
    })
    const [ equipmentData, setEquipmentData ] = useState(null);

    function updateFormData(e) {
        const { name, value } = e.target;
        const data = {...formData};
        data[name] = value;
        setFormData(data);
    }

    async function addVanEquipment() {
        if(Object.keys(formData).length === 3) {
            try {
                const reqUrl = url + '/van_equipment';
                const token = window.localStorage.getItem('token');
                const headers = { authorization: `bearer ${token}` };
                const { data } = await axios.post(reqUrl, formData, { headers });
                setEquipmentData(data.data);
                props.reload(1 + Math.random())
            } catch (error) {
                toast.error(error.response.data.message, { autoClose: 3000 })
            }
        }
    }

    return(
        <div className={modalContainer}>
            <div className="flex justify-center flex-col w-2/5">
                {
                    equipmentData != null ? 
                    <div className="flex bg-white w-full py-12 justify-center rounded-md">
                        <div>
                            <QRCode value={JSON.stringify(equipmentData)} />
                            <div className="py-1 text-center">{`Item Number - ${equipmentData.itemNumber}`}</div>
                        </div>
                    </div>
                    :
                    <div className="border border-black rounded-md bg-white w-full px-8 pt-8 pb-4">
                        <div className={modalTitle}>ADD EQUIPMENT</div>
                        <div>
                            <div className="grid grid-cols-3 mt-2">
                                <label className={label}>Equipment Name</label>
                                <div className="col-span-2">
                                    <select name="special_equipment_id" className={inputStyle} placeholder="Enter Equipment Name" onChange={e => updateFormData(e)}>
                                        {
                                            props.specialEquipments.map((eq, ind) => <option key={ind} value={+eq.id} >{eq.name}</option>)
                                        }
                                    </select>
                                    {/* <Select 
                                        testId={'equipmentName'}
                                        index={1}
                                        inputErrors={inputErrors}
                                        setInputErrors={setInputErrors}
                                        missingFields={missingFields}
                                        required={true}
                                        options={currency}
                                        className={inputStyle} 
                                        name='currency' 
                                        placeHolder='Currency'
                                        value={formData.currency} 
                                        onChange={e => updateFormData(e)} 
                                    /> */}
                                </div>
                            </div>
                            <div className="grid grid-cols-3">
                                <label className={label}>Serial Number</label>
                                <div className="col-span-2">
                                    <input name="serialNumber" type='text' className={inputStyle} placeholder="Enter Serial Number" onChange={e => updateFormData(e)}/>
                                </div>
                            </div>
                            <div className="flex justify-between py-3 px-16 gap-8">
                                <button onClick={() => props.setShowAddForm(false)} className={btnCancel}>Cancel</button>
                                <Button clickHandler={() =>addVanEquipment()} className={btnOne} name={'Submit'}/>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default AddVanEquipment;